import { useSelector } from "react-redux";

import { getUserPermissions } from "slices/auth";

const useEditing = () => {
	const userPermissions = useSelector(getUserPermissions);

	const isEditingAllowed = (obj, action) => {
		if (userPermissions.is_som_admin === true) {
			return true;
		} else if (userPermissions.is_som_monitorer === true && obj?.permission?.is_som_monitorer) {
			if (action === "EDIT") {
				if (obj?.permission?.is_som_monitorer?.EDIT === true) {
					return true;
				} else {
					return false;
				}
			} else if (action === "DEL") {
				if (obj?.permission?.is_som_monitorer?.DEL === true) {
					return true;
				} else {
					return false;
				}
			}
			return true;
		} else {
			return false;
		}
	};

	return { isEditingAllowed };
};

export default useEditing;
